import { Stack } from '@mui/material';
import PageArea from '../../components/shared/PageArea';
import { PosMappingsProvider } from './context/PosMappingsContext';
import PosMappingsTabs from './components/PosMappingsTabs';

const PosMappingsIndex = () => {
  return (
    <PosMappingsProvider>
      <PageArea>
        <Stack spacing={5}>
          <PosMappingsTabs />
        </Stack>
      </PageArea>
    </PosMappingsProvider>
  );
};

export default PosMappingsIndex;
